import $ from 'jquery';

export class AreYouSure {
  static setup() {
    $('.simple_form').areYouSure();
  }
}
